// Mock data for PTITSERVICES-PRO clone (Phase 1 - frontend only)

export const company = {
  name: "ptitservices-pro.com",
  domain: "PTITSERVICES-PRO.COM",
  tagline: "Nettoyage B2B — Grand Nord de la France",
  email: "contact@ptitservices-pro.com",
  address: "61 rue de la mairie, 62530 SERVINS",
  zone: "62530 Servins & environs",
  region: "Grand Nord de la France",
};

export const navLinks = [
  { label: "Services", href: "#services" },
  { label: "Processus", href: "#processus" },
  { label: "Pourquoi nous", href: "#pourquoi" },
  { label: "FAQ", href: "#faq" },
  { label: "Contact", href: "#contact" },
];

export const heroBadges = [
  "Réponse sous 24h",
  "Devis gratuit",
  "Assurance pro",
  "Certifié & formé",
];

export const heroImage =
  "https://images.unsplash.com/photo-1504297050568-910d24c426d3?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600";

export const services = [
  {
    id: 1,
    number: "01",
    title: "Entretien de bureaux",
    description:
      "Nettoyage régulier de vos locaux tertiaires : open-spaces, salles de réunion, sanitaires, cuisines et vitrerie. Planning sur mesure adapté à vos horaires, produits professionnels et contrôle qualité mensuel documenté.",
    tags: ["Sanitaires & vitres", "Planning sur-mesure", "Contrôle qualité"],
    image:
      "https://images.unsplash.com/photo-1764539780901-0a13bf4f4182?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  },
  {
    id: 2,
    number: "02",
    title: "Bases vie de chantiers",
    description:
      "Bungalows, vestiaires, réfectoires et sanitaires de chantier maintenus impeccables. Intervention rapide et régulière, matériel adapté aux environnements exigeants du BTP, pour le confort et l'hygiène de vos équipes.",
    tags: ["Bungalows", "Vestiaires", "Sanitaires"],
    image:
      "https://images.pexels.com/photos/12444982/pexels-photo-12444982.jpeg?auto=compress&cs=tinysrgb&w=900",
  },
  {
    id: 3,
    number: "03",
    title: "Consommables & matériel",
    description:
      "Fourniture et livraison sur site de papier, savon, produits d'entretien et distributeurs. Réassort automatique et suivi de stock pour ne jamais tomber en rupture, avec une facturation claire et maîtrisée.",
    tags: ["Papier & savon", "Produits pro", "Livraison sur site"],
    image:
      "https://images.unsplash.com/photo-1626379481874-3dc5678fa8ca?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  },
  {
    id: 4,
    number: "04",
    title: "Entretien des espaces verts",
    description:
      "Tonte, taille de haies et arbustes, désherbage, débroussaillage, ramassage de feuilles et évacuation des déchets verts. Pour les entreprises, copropriétés et collectivités situées dans un rayon de 40 km autour de Servins.",
    tags: ["Tonte & taille", "Rayon 40 km", "Déchets verts évacués"],
    image:
      "https://static.prod-images.emergentagent.com/jobs/58b0a64d-2d51-4608-b7c2-5645fa033b5b/images/de38180102a2573986f7d0d457ca2bc96d22298ee5912bd45c555842940ddf2e.jpeg",
    link: "/espaces-verts",
  },
];

export const references = [
  {
    name: "France Module Service",
    logo: "https://customer-assets.emergentagent.com/job_consommables-pro-1/artifacts/ddf0b2gw_france%20module%20service.png",
  },
  {
    name: "Nordex — Acciona Windpower",
    logo: "https://customer-assets.emergentagent.com/job_consommables-pro-1/artifacts/ll4c5zj5_cropped-cropped-Combined-Logos_cmyk_PNG.png",
  },
  {
    name: "Colas",
    logo: "https://customer-assets.emergentagent.com/job_consommables-pro-1/artifacts/wmz2nvm3_Colas_logo_nobaseline.png",
  },
];

export const whyUs = [
  {
    icon: "ShieldCheck",
    title: "Procédures strictes",
    description: "Protocoles qualité documentés, traçabilité à chaque passage.",
  },
  {
    icon: "Zap",
    title: "Intervention rapide",
    description: "Équipe mobile basée dans le Pas-de-Calais. Urgences prises en charge.",
  },
  {
    icon: "Wrench",
    title: "Matériel professionnel",
    description: "Autolaveuses, monobrosses, produits certifiés HACCP.",
  },
  {
    icon: "Leaf",
    title: "Éco-responsable",
    description: "Produits labellisés, tri sélectif, réduction de la consommation d'eau.",
  },
];

export const processSteps = [
  {
    number: "01",
    title: "Analyse du besoin",
    description: "Visite sur site et audit précis de vos locaux ou chantier.",
  },
  {
    number: "02",
    title: "Proposition chiffrée",
    description: "Devis détaillé, planning proposé, cahier des charges clair.",
  },
  {
    number: "03",
    title: "Mise en place",
    description: "Démarrage rapide, équipe dédiée, matériel livré et formé.",
  },
  {
    number: "04",
    title: "Suivi qualité",
    description: "Rapports de passage, interlocuteur unique, ajustements continus.",
  },
];

export const prestationOptions = [
  "Formule Intendance (tout inclus)",
  "Entretien de bureaux",
  "Bases vie de chantiers",
  "Consommables & matériel",
  "Entretien des espaces verts",
  "Homme toutes mains (à l'heure)",
  "Autre prestation",
];

export const frequenceOptions = [
  "Ponctuel",
  "Quotidien",
  "Hebdomadaire",
  "Bi-mensuel",
  "Mensuel",
];

export const greenFrequenceOptions = [
  "Ponctuel (remise en état)",
  "Toutes les 2 semaines (saison)",
  "Mensuel",
  "Contrat annuel (calendrier de passages)",
];

export const aiWelcome =
  "Bonjour ! Je suis l'assistant PTITSERVICES-PRO. Comment puis-je vous aider concernant l'entretien de vos bureaux, bases vie de chantiers ou consommables ?";

export const aiSuggestions = [
  "Quels sont vos délais d'intervention ?",
  "Intervenez-vous sur les chantiers ?",
  "Comment obtenir un devis ?",
];

export const aiMockReplies = {
  default:
    "Merci pour votre message ! Un conseiller vous recontactera sous 24h. Vous pouvez aussi remplir le formulaire de devis ci-dessus pour une réponse rapide.",
  devis:
    "Pour obtenir un devis gratuit sous 24h, remplissez le formulaire de la section « Devis gratuit ». Nous étudions votre besoin et proposons un planning adapté.",
  chantier:
    "Oui, nous intervenons sur les bases vie de chantiers : bungalows, vestiaires, réfectoires et sanitaires. Équipe mobile réactive dans les Hauts-de-France.",
  delai:
    "Notre équipe mobile basée dans le Pas-de-Calais intervient rapidement, avec prise en charge des urgences. Réponse à toute demande sous 24h.",
};

export const stats = [
  { value: "120+", label: "Contrats actifs" },
  { value: "24h", label: "Délai de réponse" },
  { value: "4 ans", label: "D'expérience B2B" },
  { value: "98%", label: "Clients fidélisés" },
];

export const sectors = [
  { icon: "Building2", title: "Bureaux & tertiaire", text: "Sièges, open-spaces, cabinets, agences" },
  { icon: "HardHat", title: "BTP & chantiers", text: "Bases vie, bungalows, réfectoires" },
  { icon: "Factory", title: "Industrie", text: "Ateliers, zones de production, entrepôts" },
  { icon: "Stethoscope", title: "Santé & médical", text: "Cabinets, cliniques, laboratoires" },
  { icon: "ShoppingBag", title: "Commerces", text: "Boutiques, showrooms, surfaces de vente" },
  { icon: "GraduationCap", title: "Collectivités", text: "Écoles, mairies, espaces publics" },
];

export const testimonials = [
  {
    name: "Responsable QHSE",
    company: "Groupe industriel — Béthune",
    quote:
      "Une équipe fiable et réactive. Les protocoles sont respectés à la lettre et les rapports de passage nous font gagner un temps précieux lors des audits.",
    initials: "GI",
  },
  {
    name: "Conducteur de travaux",
    company: "Entreprise BTP — Lens",
    quote:
      "L'entretien de nos bases vie est irréprochable, même sur des chantiers difficiles. Intervention rapide et interlocuteur unique, exactement ce qu'il nous fallait.",
    initials: "BT",
  },
  {
    name: "Office Manager",
    company: "Société de services — Arras",
    quote:
      "Depuis que nous travaillons avec PTITSERVICES-PRO, plus aucune remarque des collaborateurs sur la propreté des locaux. Un vrai partenaire de confiance.",
    initials: "OM",
  },
];

export const faq = [
  {
    q: "Sous quel délai obtenez-vous un devis ?",
    a: "Nous répondons à toute demande sous 24h ouvrées. Après une visite ou un échange, nous vous transmettons une proposition chiffrée détaillée avec un planning adapté à votre activité.",
  },
  {
    q: "Intervenez-vous en dehors des heures de bureau ?",
    a: "Oui. Nous adaptons nos passages à vos contraintes : tôt le matin, en soirée ou le week-end, afin de ne jamais perturber votre activité.",
  },
  {
    q: "Vos produits sont-ils respectueux de l'environnement ?",
    a: "Nous privilégions des produits labellisés et des protocoles éco-responsables : dosage maîtrisé, tri sélectif et réduction de la consommation d'eau et d'énergie.",
  },
  {
    q: "Proposez-vous un contrat sans engagement long ?",
    a: "Nos prestations ponctuelles sont sans engagement. Pour les prestations récurrentes, nous proposons des contrats souples, ajustables selon l'évolution de vos besoins.",
  },
  {
    q: "Gérez-vous aussi la fourniture des consommables ?",
    a: "Oui. Nous livrons et réassortissons papier, savon, produits d'entretien et distributeurs directement sur site, avec un suivi de stock pour éviter toute rupture.",
  },
];

export const guarantees = [
  "Entreprise assurée en responsabilité civile professionnelle",
  "Personnel formé, déclaré et encadré",
  "Contrôles qualité réguliers et traçables",
  "Interlocuteur unique dédié à votre compte",
];

